import {Component, Input, OnInit} from '@angular/core';
import {VMAResult} from '../estimate.component';
import {Sort} from '@angular/material/sort';

@Component({
  selector: 'app-vma-result',
  templateUrl: './vma-result.component.html',
  styleUrls: ['./vma-result.component.css']
})
export class VmaResultComponent implements OnInit {
  @Input() result: VMAResult;
  @Input() columns: string[];

  vmaColumns: string[] = ['algorithm', 'price', 'liquidity', 'time', 'case'];
  vmaDataSource = [];
  details: any[] = [];

  constructor() { }

  ngOnInit() {
    for (let i = 0; i < this.columns.length; i++) {
      this.details.push({
        label: this.columns[i],
        value: this.result.row[i],
        idx: i
      });
    }

    this.vmaDataSource.push({algorithm: 'True Values', price: this.result.price, liquidity: this.result.liquidity});
    this.vmaDataSource.push({algorithm: 'Machine Learning', time: this.result.ml.time});
    for (let model in this.result.ml.price) {
      this.vmaDataSource.push({ algorithm: model, price: this.result.ml.price[model] })
    }
    this.vmaDataSource.push({algorithm: 'Comparable', ...this.result.comparable});
  }

  sortDetails(sort: Sort) {
    this.details = this.details.sort((a, b) => {
      if (!sort.active || sort.direction === '') {
        return a.idx - b.idx;
      }
      if (sort.direction === 'asc') {
        return a.label.localeCompare(b.label);
      } else {
        return b.label.localeCompare(a.label);
      }
    });
  }

  renderRow(row: string) {
    //console.log(row);
    if (row === null) {
      row = 'na';
    } else if (typeof row !== 'string') {
      // @ts-ignore
      row = row.toString();
    }
    if (row && (row.startsWith('http://') || row.startsWith('https://'))) {
      return `<a href="${row}" target="_blank">${row}</a>`;
    }
    return row;
  }
}
